/// This implements a react hook (and wrapper) component that ensure of the components using it,
/// only one is visible at the same time.
/// It's currently intended to prevent multiple modals from showing up at once
import * as React from "react";
import { generate as shortid } from "shortid";
class MutexContextValue {
    mQueue = [];
    get current() {
        return this.mQueue.length > 0 ? this.mQueue[0] : null;
    }
    add(newItem) {
        const idx = this.mQueue.indexOf(newItem);
        if (idx === -1) {
            this.mQueue.unshift(newItem);
        }
    }
    remove(item) {
        const idx = this.mQueue.indexOf(item);
        if (idx !== -1) {
            this.mQueue.splice(idx, 1);
        }
    }
}
const MutexContext = React.createContext(null);
export function createQueue() {
    return new MutexContextValue();
}
export const MutexProvider = ({ children }) => {
    const queueRef = React.useRef();
    if (queueRef.current === undefined) {
        queueRef.current = new MutexContextValue();
    }
    return React.createElement(MutexContext.Provider, { value: queueRef.current }, children);
};
export const MutexConsumer = MutexContext.Consumer;
export function useMutex(show) {
    const ctx = React.useContext(MutexContext);
    const mutexId = useRandomId();
    const [, updateState] = React.useState();
    const forceUpdate = React.useCallback(() => updateState({}), []);
    React.useEffect(() => {
        if (!ctx) {
            return;
        }
        if (show) {
            ctx.add(mutexId);
            forceUpdate();
        }
        return () => {
            ctx.remove(mutexId);
            forceUpdate();
        };
    }, [show]);
    return ctx?.current === mutexId && mutexId !== null;
}
export function useRandomId() {
    const ref = React.useRef();
    if (ref.current === undefined) {
        ref.current = shortid();
    }
    return ref.current;
}
export function MutexWrapper(props) {
    // const primary = useMutex(props.show);
    // return primary ? React.createElement('div', undefined, props.children) : null;
    return React.createElement("div", undefined, props.children);
}
